import React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import MuiTablePagination from "@material-ui/core/TablePagination/TablePagination";
import { Theme } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    select: {
      ...theme.typography.caption,
      width: "20px"
    }
  });

type Props = {
  classes: any;
  onPageChange: (event: any, page: number) => void;
  onRowCountChange: (event: any) => void;
  page: number;
  rowsPerPage: number;
  totalRowCount: number;
};

const TablePagination = ({
  classes,
  totalRowCount,
  rowsPerPage,
  page,
  onPageChange,
  onRowCountChange
}: Props) => {
  return (
    <MuiTablePagination
      classes={{
        select: classes.select
      }}
      component="div"
      count={totalRowCount}
      rowsPerPage={rowsPerPage}
      page={page}
      backIconButtonProps={{
        "aria-label": "Previous Page"
      }}
      nextIconButtonProps={{
        "aria-label": "Next Page"
      }}
      onChangePage={onPageChange}
      onChangeRowsPerPage={onRowCountChange}
      rowsPerPageOptions={[5, 10, 25, 50, 100]}
    />
  );
};

export default withStyles(styles)(TablePagination);
